// extracted by mini-css-extract-plugin
module.exports = {"section":"easy-to-implement_section__hP1RS","mainText":"easy-to-implement_mainText__Y24Qv","title":"easy-to-implement_title__iwcu6"};